import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { FaArrowLeft, FaUser, FaEnvelope, FaPhone } from 'react-icons/fa';

const Container = styled.div`
  padding: 1rem;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 16px;
  cursor: pointer;
  padding: 0.5rem 0;
  margin-bottom: 1rem;

  svg {
    font-size: 20px;
  }
`;

const Form = styled.form`
  background-color: var(--bg-secondary);
  border-radius: 10px;
  padding: 1.5rem;
`;

const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  color: var(--text-primary);
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: 5px;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  font-size: 16px;

  &:focus {
    outline: none;
    border-color: var(--primary-color);
  }
`;

const InputGroup = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  svg {
    position: absolute;
    left: 1rem;
    color: var(--text-secondary);
  }

  input {
    padding-left: 2.5rem;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 1rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: var(--primary-color-dark);
  }
`;

const EditProfile: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: 'Thomas Dupont',
    email: 'thomas.dupont@example.com',
    phone: '+32 487 65 43 21'
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Implement profile update logic
    console.log('Updating profile:', formData);
    navigate('/profile');
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <Container>
      <BackButton onClick={() => navigate('/profile')}>
        <FaArrowLeft />
        {t('common.back')}
      </BackButton>

      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label>{t('profile.name')}</Label>
          <InputGroup>
            <FaUser />
            <Input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder={t('profile.namePlaceholder')}
            />
          </InputGroup>
        </FormGroup>

        <FormGroup>
          <Label>{t('profile.email')}</Label>
          <InputGroup>
            <FaEnvelope />
            <Input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder={t('profile.emailPlaceholder')}
            />
          </InputGroup>
        </FormGroup>

        <FormGroup>
          <Label>{t('profile.phone')}</Label>
          <InputGroup>
            <FaPhone />
            <Input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder={t('profile.phonePlaceholder')}
            />
          </InputGroup>
        </FormGroup>

        <SubmitButton type="submit">
          {t('profile.saveChanges')}
        </SubmitButton>
      </Form>
    </Container>
  );
};

export default EditProfile; 